import CryptoJS from 'crypto-js';

export const storePurpose = (name, data, purpose, isSession = false) => {
    const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), purpose).toString();
    setStorageItem(name, encryptedData, isSession);
}

export const providePurpose = (name, purpose, isSession = false) => {
   
    const encryptedData = getStorageItem(name, isSession);
    if (encryptedData) {
        try {
            const decryptedData = CryptoJS.AES.decrypt(encryptedData, purpose).toString(CryptoJS.enc.Utf8);
            return JSON.parse(decryptedData);
        }
        catch (error) {
            console.log(error);
            localStorage.removeItem(name);
        }
    }
    return null;
}

export const clearPurpose = (purposeList) => {
    if (purposeList && purposeList.length > 0) {
        purposeList.map((value) => localStorage.removeItem(value));
    }
}

const setStorageItem = (name, item, isSession = false) => {
    if (isSession) {
        sessionStorage.setItem(name, item);
    } else {
        localStorage.setItem(name, item);
    }
}

const getStorageItem = (name, isSession = false) => {
    if (isSession) {
        return sessionStorage.getItem(name);
    } else {
        return localStorage.getItem(name);
    }
}